import React from "react";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";
import {
  convertStraight,
  convertThenFormat,
} from "../../../common-data/Converts";

const PlanDetails = ({ rowData }) => {
  const tbColumns = [
    {
      dataField: "plan_name",
      text: "plan name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.plan_name || "NA"}</span>;
      },
    },

    {
      dataField: "price",
      text: "price",
      formatter: (_, row) => (
        <span className="tb-data">
          {`₹${convertThenFormat(row?.price || 0)}`}
        </span>
      ),
    },
    {
      dataField: "start_date",
      text: "plan duration",
      formatter: (_, row) => (
        <span className="tb-data minWidth100">
          {row?.start_date ? convertStraight(row.start_date) : "-"}/
          {row?.expire_date ? convertStraight(row.expire_date) : "-"}
        </span>
      ),
    },
    {
      dataField: "status",
      text: "status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}>
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <div className="fullWidthFlexCenter overflowAuto separatedTable">
      <PaymentLinkTable
        tableData={rowData?.regular_plans || []}
        tableColumns={tbColumns}
      />
    </div>
  );
};

export default PlanDetails;